import { render, staticRenderFns } from "./MyAside.vue?vue&type=template&id=ba898ba6&scoped=true&"
import script from "./MyAside.vue?vue&type=script&lang=js&"
export * from "./MyAside.vue?vue&type=script&lang=js&"
import style0 from "./MyAside.vue?vue&type=style&index=0&id=ba898ba6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba898ba6",
  null
  
)

export default component.exports